(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flex-carousel"] && !Shopify.designMode) return;
  try {
    
  const hideIdleArrowSelector = 'flex-carousel.flex-carousel--hide-idle-arrows';

  function syncFlexCarouselIdleArrows(carousel) {
    const container = carousel.querySelector('[ref="container"]');
    const wrapper = container && container.querySelector('.swiper-wrapper');
    const controls = carousel.querySelector('[ref="controls"]');
    if (!container || !wrapper || !controls) return;

    const fits = wrapper.scrollWidth <= container.clientWidth + 2;
    const locked = Boolean(carousel.swiperInstance && carousel.swiperInstance.isLocked);
    carousel.classList.toggle('flex-carousel--no-scroll', fits || locked);
  }

  function bindFlexCarouselIdleArrows(carousel) {
    if (carousel.dataset.idleArrowsBound === 'true') return;
    carousel.dataset.idleArrowsBound = 'true';

    const run = () => syncFlexCarouselIdleArrows(carousel);
    carousel.addEventListener('carousel:ready', run);
    window.addEventListener('resize', run);

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(run);
      observer.observe(carousel);
      const container = carousel.querySelector('[ref="container"]');
      if (container) observer.observe(container);
    }

    run();
    requestAnimationFrame(run);
  }

  function initFlexCarouselIdleArrows(root) {
    (root || document).querySelectorAll(hideIdleArrowSelector).forEach(bindFlexCarouselIdleArrows);
  }

  initFlexCarouselIdleArrows();
  document.addEventListener('shopify:section:load', (event) => initFlexCarouselIdleArrows(event.target));

  } catch(e) { console.error(e); }
})();
})();
